import React from "react";
import { Input } from "@mui/material";

interface PaymentInputFieldProps {
  label: string;
  value: number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  roundAmount: (value: any) => string;
  isEditable: boolean;
}

const PaymentInputField: React.FC<PaymentInputFieldProps> = ({ label, value, onChange, roundAmount, isEditable }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let newValue = e.target.value;
    // Allow only numbers with up to 2 decimal places
    if (!/^\d*\.?\d{0,2}$/.test(newValue)) {
      return;
    }

    if (newValue && newValue.length > 1 && newValue.startsWith("0") && !newValue.startsWith("0.")) {newValue = newValue.replace(/^0+/, ""); }
    if (onChange) {onChange({ ...e, target: { ...e.target, value: newValue } }); }};

  const handleBlur = () => {
    if (!value && onChange) { onChange({ target: { value: "0" } } as React.ChangeEvent<HTMLInputElement>); }
  };

  return (
    <div className="flex justify-between items-center py-0.5 text-sm">
      <span className="px-10">{label}</span>
      {isEditable ? (
        <Input
          type="number"
          value={value === 0 ? "" : value}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="0"
          inputProps={{ step: "any" }}
          disableUnderline
          className="w-[100px] h-9 text-right text-gray-800 placeholder:text-gray-700 border border-gray-400 rounded-md px-2 py-1"
        />
      ) : (
        <span className="font-medium">{roundAmount(value)} QAR</span>
      )}
    </div>
  );
};

export default PaymentInputField;
